import { render, staticRenderFns } from "./ChoosePapers.vue?vue&type=template&id=4364e180&scoped=true"
import script from "./ChoosePapers.ts?vue&type=script&lang=ts&external"
export * from "./ChoosePapers.ts?vue&type=script&lang=ts&external"
import style0 from "./ChoosePapers.vue?vue&type=style&index=0&id=4364e180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364e180",
  null
  
)

export default component.exports